import Reveal from '@/components/base/Reveal';
import SectionLabel from '@/components/base/SectionLabel';
import { heritageImage } from '../data';

export default function Heritage() {
  return (
    <section id="story" className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-12 items-center gap-12 px-4 md:px-6">
        {/* Text */}
        <Reveal className="lg:col-span-6 order-2 lg:order-1">
          <SectionLabel>Heritage</SectionLabel>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl leading-[1.12] font-medium text-foreground-950">
            Bringing Indian Textile Tradition Closer to Home.
          </h2>
          <p className="mt-6 max-w-lg text-[15px] md:text-base leading-relaxed text-foreground-700">
            From the colours and textures of traditional Indian textiles to the occasions
            that bring families together, SRM Textiles celebrates clothing that carries
            cultural meaning.
          </p>
          <p className="mt-4 max-w-lg text-[15px] md:text-base leading-relaxed text-foreground-600">
            Based in Liverpool, we bring authentic sarees, dhotis, veshtis and Indian ethnic
            wear to customers across the UK — preserving the heritage of South Indian textiles
            while making them easy to discover and enjoy.
          </p>
          <div className="mt-8 grid grid-cols-2 gap-6 max-w-md">
            <div className="border-l-2 border-accent-300 pl-4">
              <p className="font-heading text-3xl font-medium text-primary-600">Authentic</p>
              <p className="mt-1 text-[13px] text-foreground-600">Traditional Indian styles</p>
            </div>
            <div className="border-l-2 border-accent-300 pl-4">
              <p className="font-heading text-3xl font-medium text-primary-600">UK Focused</p>
              <p className="mt-1 text-[13px] text-foreground-600">Closer to your community</p>
            </div>
          </div>
        </Reveal>

        {/* Image */}
        <Reveal delay={120} className="lg:col-span-6 order-1 lg:order-2">
          <div className="img-zoom rounded-lg overflow-hidden">
            <img
              src={heritageImage}
              alt="Traditional Indian textile weaving detail with rich gold and burgundy patterns"
              className="h-[460px] md:h-[540px] w-full object-cover object-top"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}